<template>
  <div class="change_inform">
    <div class="title">产品列表</div>
    <div style="overflow: auto; margin-right: 16px">
      <el-form class="rule-form" style="overflow: auto; width: 100%; margin: 0" :model="product" :inline="true" ref="form" :inline-message="true">
        <table class="statistics_table">
          <tbody>
            <tr>
              <th style="width: 5rem">序号</th>
              <th style="width: 8rem">
                <font color="red">*</font>
                单价
              </th>
              <th style="width: 8rem">
                <font color="red">*</font>
                设备名称
              </th>
              <th style="width: 8rem">
                <font color="red">*</font>
                数量
              </th>
              <th style="width: 8rem">
                <font color="red">*</font>
                单位
              </th>
              <th style="width: 18.75rem">
                <font color="red">*</font>
                技术参数
              </th>
              <th style="width: 8rem">
                <font color="red">*</font>
                品牌
              </th>
              <th style="width: 18.75rem">
                <font color="red">*</font>
                货期要求
                <br />
                (自合同签订之日起X个自然日)
              </th>
              <th style="width: 21.25rem">
                <font color="red">*</font>
                结算方式
              </th>
              <th style="width: 18.25rem">
                <font color="red">*</font>
                溯源机构
              </th>
              <th style="width: 20.75rem">
                <font color="red">*</font>
                保修要求
                <br />
                (自甲方内部验收之日起X个自然日)
              </th>
              <th style="width: 8rem">
                <font color="red">*</font>
                其他要求
              </th>
              <th style="width: 6.25rem">备注</th>
              <th style="width: 21.875rem">交货地址</th>
            </tr>
            <template v-for="(data, index) in product.dataList">
              <tr :key="index">
                <td>{{ index + 1 }}</td>
                <td>单价</td>
                <td>{{ data.detail.InstrumentName }}</td>
                <td>{{ data.detail.Count }}</td>
                <td>{{ data.detail.Unit }}</td>
                <td><el-link type="info" :underline="false" @click="fnviewPdf(data.detail.FileId)">浏览</el-link></td>
                <td>{{ data.detail.Brand }}</td>
                <td>自合同签订之日起{{ data.detail.DeliveryTime }}个自然日</td>
                <td>{{ data.detail.SettlementMethodName }}</td>
                <td>{{ data.detail.TraceabilityOrganization }}</td>
                <td>自甲方内部验收之日起{{ data.detail.WarrantyRequirement }}个自然日</td>
                <td>{{ data.detail.OtherRequirement }}</td>
                <td>/</td>
                <td>{{ data.detail.ReceivingAddress }}</td>
              </tr>
              <tr :key="index">
                <td></td>
                <td><el-input v-model="data.offer.PerPrice"></el-input></td>
                <td><el-input v-model="data.offer.InstrumentName"></el-input></td>
                <td><el-input v-model="data.offer.Count"></el-input></td>
                <td><el-input v-model="data.offer.Unit"></el-input></td>
                <td>
                  <div class="file_wrap">
                    <el-upload
                      :action="uploadUrl"
                      :limit="1"
                      :before-remove="removeConfirm"
                      :before-upload="beforeUpload"
                      :on-remove="handleRemove"
                      :on-change="fileChange"
                      :on-exceed="exceedFile"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :auto-upload="true"
                      :file-list="data.offer.FileList"
                      :data="{ offer: data.offer, index: index }"
                      :http-request="uploadTechnicalFile"
                      accept=".pdf,.doc,.docx,.xls,.xlsx"
                      ref="uploader"
                    >
                      <el-button size="mini" type="primary" plain>点击上传</el-button>
                    </el-upload>
                  </div>
                </td>
                <td><el-input v-model="data.offer.Brand"></el-input></td>
                <td><el-input v-model="data.offer.DeliveryTime"></el-input></td>
                <td>
                  <el-select v-model="data.offer.SettlementMethodName" placeholder="请选择">
                    <el-option v-for="item in settleMethods" :key="item.value" :label="item.label" :value="item.label"></el-option>
                  </el-select>
                </td>
                <td><el-input v-model="data.offer.TraceabilityOrganization"></el-input></td>
                <td><el-input v-model="data.offer.WarrantyRequirement"></el-input></td>
                <td><el-input v-model="data.offer.OtherRequirement"></el-input></td>
                <td><el-input v-model="data.offer.Remark"></el-input></td>
                <td></td>
              </tr>
            </template>
          </tbody>
        </table>
      </el-form>
    </div>
    <div class="title">供应商联系信息</div>
    <el-form :inline="true" :model="supplierInfo" class="form_table" ref="ruleForm1" :rules="rules2" :inline-message="true">
      <el-form-item label="联系人" prop="Contact"><el-input v-model="supplierInfo.Contact"></el-input></el-form-item>
      <el-form-item label="联系电话" prop="Phone"><el-input v-model="supplierInfo.Phone"></el-input></el-form-item>
      <el-form-item label="联系地址" prop="Address"><el-input v-model="supplierInfo.Address"></el-input></el-form-item>
      <el-form-item label="邮箱" prop="Email"><el-input v-model="supplierInfo.Email"></el-input></el-form-item>
    </el-form>
    <div class="btn_wrap changeInform_btn_wrap">
      <span class="btn_1" @click="fnSaveOffer(false)">保存报价草稿</span>
      <span class="btn_1" @click="fnSaveOffer(true)">上传报价单</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: { type: Object },
    settleMethods: { type: Array },
    supplierInfo: { type: Object }
  },
  data() {
    return {
      uploadUrl: '',
      rules2: {
        Contact: [{ required: true, message: '最多输入十个字符!', trigger: 'blur' }],
        Phone: [{ required: true, message: '最多输入十个字符!', trigger: 'blur' }],
        Address: [{ required: true, message: '最多输入十个字符!', trigger: 'blur' }],
        Email: [{ required: true, message: '最多输入十个字符!', trigger: 'blur' }]
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    fnSaveOffer(flag) {
      let data = []
      let that = this

      let flag2 = true
      this.product.dataList.forEach((item, index) => {
        if (isNaN(item.offer.PerPrice) || item.offer.PerPrice == '') {
          flag2 = false
          that.$message.error(`序号${index + 1},报价单价只能为数字`)
          return false
        }
        if (item.offer.PerPrice <= 0) {
          flag2 = false
          that.$message.error(`序号${index + 1},单价必须大于0`)
          return false
        }

        if (item.offer.InstrumentName == '' || item.offer.InstrumentName == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请输入设备名称`)
          return false
        }
        if (isNaN(item.offer.Count) || item.offer.Count == '' || item.offer.Count == null) {
          flag2 = false
          that.$message.error(`序号${index + 1},数量只能为数字`)
          return false
        }

        if (item.offer.Count > item.detail.Count) {
          flag2 = false
          that.$message.error(`序号${index + 1}，数量不能大于${item.detail.Count}`)
          return false
        }
        if (item.offer.Unit == '' || item.offer.Unit == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请输入单位`)
          return false
        }
        if (item.offer.FileId == '' || item.offer.FileId == null || item.offer.FileId == 0) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请上传技术参数`)
          return false
        }
        if (item.offer.Brand == '' || item.offer.Brand == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请输入品牌`)
          return false
        }
        if (item.offer.DeliveryTime == '' || item.offer.DeliveryTime == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请输入货期要求`)
          return false
        }
        if (isNaN(item.offer.DeliveryTime)) {
          flag2 = false
          that.$message.error(`序号${index + 1},货期要求只能为数字`)
          return false
        }
        if (item.offer.SettlementMethodName == '' || item.offer.SettlementMethodName == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请选择结算方式`)
          return false
        }
        if (item.offer.TraceabilityOrganization == '' || item.offer.TraceabilityOrganization == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请输入溯源机构`)
          return false
        }
        if (item.offer.WarrantyRequirement == '' || item.offer.WarrantyRequirement == null) {
          flag2 = false
          that.$message.error(`序号${index + 1}，请输入保修要求`)
          return false
        }
        if (isNaN(item.offer.WarrantyRequirement)) {
          flag2 = false
          that.$message.error(`序号${index + 1},保修要求只能为数字`)
          return false
        }

        item.offer.Contact = that.supplierInfo.Contact
        item.offer.Phone = that.supplierInfo.Phone
        item.offer.Address = that.supplierInfo.Address
        item.offer.Email = that.supplierInfo.Email
        data.push(item.offer)
      })
      if (flag2) {
        this.postRequest('/InQuiryPrice/SaveOffers', {
          offerStr: JSON.stringify(data)
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('操作成功')
            this.$emit('reload', flag)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    fnviewPdf(fileId) {
      console.log(fileId)
      let routerData = this.$router.resolve({
        name: 'ReadPDF',
        query: {
          pdfUrl: encodeURIComponent('/Common/GetFileStream?fileId=' + fileId),
          pdfUrl1: ''
        }
      })
      window.open(routerData.href, '_blank')
    },
    uploadTechnicalFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data)
          this.product.dataList[params.data.index].offer.FileList = res.data.FileList
          this.product.dataList[params.data.index].offer.FileId = res.data.FileList[0].fileId
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传1个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      if (file.hasOwnProperty('response')) {
        this.postRequest('/InQuiryPrice/DeleteTechnicalParam', {
          fileId: file.response.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            fileList.clear()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileIds.push(response.fileId)
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleUpload(raw) {},
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg.toLowerCase() === 'pdf' || testmsg.toLowerCase() === 'doc' || testmsg.toLowerCase() === 'docx' || testmsg.toLowerCase() === 'xls' || testmsg.toLowerCase() === 'xlsx'
      // const isLt2M = file.size / 1024 / 1024 < 10
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension) {
        this.$message({
          message: '只能上传word、excel、pdf文件!',
          type: 'warning'
        })
      }
      return extension
    }
  }
}
</script>

<style lang="scss" scoped>
.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;
  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}
.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;
    .el-input {
      width: 200px;
    }
  }
  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }
  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }
  .el-input {
    width: 300px;
    margin-right: 8px;
  }
  .businessTermEndDate {
    margin-bottom: 0 !important;
    .el-input {
      width: 100% !important;
    }
    .el-form-item__label:before {
      display: none;
    }
    .el-form-item__content {
      border-bottom: none;
    }
  }
}
::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}
.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;
  .product_form {
    margin-bottom: 0;
  }
}
.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}
.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;
    .el-range-input {
      font-size: 14px;
    }
  }
}
.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;
    .el-tree-node {
      display: inline-block;
    }
  }
}
.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}
.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 100%;
  table-layout: fixed;
  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }
  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }
  tr {
    border-bottom: 1px solid #95c7f0;
  }
}
.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
